export type NoteScope =
  | { kind: 'org'; groupGuid: string }
  | { kind: 'incident'; incidentId: string };

export type Note = {
  id: string;
  groupGuid: string;
  incidentId: string | null;
  title: string;
  body: string;
  shared: boolean;
  createdBy: string | null;
  createdByName: string | null;
  isMine: boolean;
  createdAt: string;
  updatedAt: string;
};

export type NoteDraft = { title: string; body: string; shared: boolean };

export function noteScopeParams(scope: NoteScope) {
  return scope.kind === 'org'
    ? { groupGuid: scope.groupGuid }
    : { incidentId: scope.incidentId };
}

export function noteScopeKey(scope: NoteScope | null): string {
  if (!scope) return '';
  return scope.kind === 'org'
    ? `org:${scope.groupGuid}`
    : `incident:${scope.incidentId}`;
}

/** Plain-text preview of a note body for its card. */
export function noteExcerpt(html: string, max = 160): string {
  const text = html
    .replace(/<\/(p|div|li|h[1-6])>/gi, ' ')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length > max ? `${text.slice(0, max - 1).trimEnd()}…` : text;
}

export function isNoteDirty(note: Note, draft: NoteDraft): boolean {
  return (
    note.title !== draft.title.trim() ||
    note.body !== draft.body ||
    note.shared !== draft.shared
  );
}
